/**
 * zenchef.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Opens the Zenchef booking widget from our own buttons.
 * Triggers: any [data-reservieren] element or link with href="#reservieren"
 * (the header pill and the FAQ answer use the latter) — same contract as
 * takeaway.js so both CTAs behave alike.
 *
 * Why not the SDK's built-in data-zc-action: its click handler tests the
 * literal event.target for the attribute instead of walking up the tree, so
 * a click landing on a nested <span> or <svg> inside the button is ignored.
 * Ours matches with closest().
 *
 * Readiness: the SDK assigns window.ZenchefWidget as the very last step of
 * its init, so its presence means open() is safe to call. It loads async and
 * boots on a timer, so an early click waits for it here (calls before init
 * are dropped by the SDK with a console warning).
 */

(() => {
  "use strict";

  var SELECTOR = '[data-reservieren], a[href="#reservieren"], a[href$="#reservieren"]';
  var READY_TIMEOUT = 8000;
  var POLL_INTERVAL = 100;

  function whenReady(callback, waited) {
    var widget = window.ZenchefWidget;
    if (widget && typeof widget.open === "function") {
      callback(widget);
      return;
    }
    var elapsed = waited || 0;
    if (elapsed >= READY_TIMEOUT) return;
    window.setTimeout(function () {
      whenReady(callback, elapsed + POLL_INTERVAL);
    }, POLL_INTERVAL);
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest(SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    whenReady(function (widget) {
      widget.open();
    });
  });
})();
